import PropTypes from "prop-types";

import CardShell, { BackToSignIn } from "./card_shell";

const MagicLinkConfirmationPage = ({
  paths,
  title = "Check your email",
  body = [
    "We've sent you a sign in link to your email address.",
    "Click the link to log in. The link expires in 24 hours.",
  ],
}) => (
  <CardShell size="wide">
    <div className="text-center">
      <h1 className="auth-title">{title}</h1>
      {body.map((line) => (
        <p key={line} className="auth-confirmation-copy">
          {line}
        </p>
      ))}
      <BackToSignIn path={paths.signIn} />
    </div>
  </CardShell>
);

MagicLinkConfirmationPage.propTypes = {
  paths: PropTypes.shape({
    signIn: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string,
  body: PropTypes.arrayOf(PropTypes.string),
};

export default MagicLinkConfirmationPage;
